module.exports = __webpack_public_path__ + "img/hubspot-mini.3827d364.png";